import { DirectoryPathItem } from '../../imCustomRuleDirectoryPathFormField/IntegrityMonitorDirectoryPathFormFieldWebComponent';
import {
  IntegrityMonitorEntityType,
  IntegrityMonitorPlatform,
  IntegrityMonitorSeverity,
} from '../../../../common/utils/types';

export enum CustomRuleFormEvents {
  CUSTOM_RULE_SAVED = 'customRuleSaved',
}

export interface CustomRuleRecord {
  _id?: string;
  companyId: string;
  ruleName: string;
  description: string | null;
  severity: IntegrityMonitorSeverity;
  platform: IntegrityMonitorPlatform;
  entities: [CustomRuleEntity];
}

export interface CustomRuleAttributes {
  [key: string]: { enabled: boolean; action: string };
}

export interface CustomRuleFormData {
  _id?: string;
  companyId: string;
  general: {
    name: string;
    description: string | null;
    severity: number;
    entityType: number;
  };
  security: CustomRuleSecurityFormData;
}

export type CustomRuleSecurityFormData =
  | CustomRuleFileFormData
  | CustomRuleDirectoryFormData
  | CustomRuleRegistryKeyFormData
  | CustomRuleRegistryValueFormData;

export interface CustomRuleFileFormData {
  os: IntegrityMonitorPlatform;
  keys: string[];
  attributes: CustomRuleAttributes;
}

export interface CustomRuleDirectoryFormData {
  os: IntegrityMonitorPlatform;
  keys: DirectoryPathItem[];
  attributes: CustomRuleAttributes;
}

export interface CustomRuleRegistryKeyFormData {
  registryKeys: string[];
  attributes: CustomRuleAttributes;
}

export interface CustomRuleRegistryValueFormData {
  registryValues: string[];
  attributes: CustomRuleAttributes;
}

export interface CustomRuleEntity {
  entityType: IntegrityMonitorEntityType;
  attributes: string[];
  actions: CustomRuleActionMapping[];
  specifics: any;
}

export interface CustomRuleActionMapping {
  attribute: string;
  action: string;
}
